import "./ScaffoldingInAscot.module.css";
import Header from "@/reusable_sections/Header";
import Ascot from "./sections/Ascot";
import AscotCoverage from "./sections/AscotCoverage";
import AscotSafety from "./sections/AscotSafety";
import AscotFaq from "./sections/AscotFaq";
import FinalCta from "./sections/FinalCta";
import Footer from "@/reusable_sections/Footer";
export default function ScaffoldingInAscotPage() {
  return <div>
      <Header />
      <Ascot />
      <AscotCoverage />
      <AscotSafety />
      <AscotFaq />
      <FinalCta />
      <Footer />
    </div>;
}